import React, {useContext, useEffect, useRef, useState} from 'react';
import {Context} from "../index";
import {observer} from "mobx-react-lite";
import File from "./File";
import {useLocation} from "react-router-dom";
import Modal from "./Modal";
import "./css/SideBar.css";

const SideBar = () => {
    const {userStore, fileStore} = useContext(Context);
    const location = useLocation();
    const loc = location.pathname;
    const splited = loc.split("/");
    const fileId = splited[splited.indexOf("file")+1];
    fileStore.setCurrentFile(fileId);

    const side = useRef(null);

    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(false);
    const [numFileToDel, setNumFileToDel] = useState(null);

    function formatDate(iso) {
        const date = new Date(iso);

        return new Intl.DateTimeFormat("ru-RU", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        }).format(date);
    }

    async function getFiles() {
        setLoading(true);
        try {
            await fileStore.getFiles(userStore.user.id);
        } catch (e) {
            alert(`ОКАК: Ошибка загрузки пользовательских файлов - ${e?.response?.data?.message || e}`);
        } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        getFiles();
    }, [])

    useEffect(() => {
        userStore.openSide === true && side.current.classList.add("open");
    }, [userStore.openSide])

    function closeSide() {
        side.current.classList.remove("open");
        userStore.setOpenSide(false);
    }

    async function uploadFile(file) {
        try {
            await fileStore.upload(file, userStore.user.id);
            await getFiles();
        } catch (e) {
            alert(`ОКАК: Ошибка загрузки файла - ${e?.response?.data?.message || e}`);
        }
    }

    async function deleteFile(num) {
        try {
            fileStore.setCurrentInfo(null);
            fileStore.setCurrentFile(null);
            await fileStore.deleteFile(userStore.user.id, num)
            fileStore.setCurrentInfo(null);
            await getFiles();
        } catch (e) {
            alert(`ОКАК: Ошибка удаления файла - ${e?.response?.data?.message || e}`);
        }
    }

    return (
        <aside ref={side}>
            <div id="logo" style={{marginTop: "20px"}}>
                <a href="/" style={{whiteSpace: "nowrap"}}>
                    <span id="five-logo">5</span>core-analy<span style={{color: "red", fontFamily: "Poppins"}}>2</span>er
                </a>
                <i className="icon-x" onClick={() => closeSide()}></i>
            </div>
            <h3>Ваши файлы</h3>
            {!loading ?
                <>
                    <div style={{overflowY: "auto", maxHeight: "50vh"}}>
                        {fileStore.files.length > 0 ? fileStore.files.map((f, i) => {
                            return <File key={i} onDelete={(num) => {setModal(true); setNumFileToDel(num)}} name={f.name} num={i+1} filled={i === fileId-1} date={formatDate(f.createdAt)} />
                        }) : "У тебя нет загруженных файлов"}
                    </div>

                    <div style={{textAlign: "center", marginTop: "20px"}}>
                        <label>
                            <input type="file" onChange={(e) => uploadFile(e.target.files[0])} />
                            <span style={{display: "flex", alignItems: "center"}}><i className="icon-arrow-up-from" style={{marginRight: "3px"}}></i>Загрузить файл</span>
                        </label>
                    </div>

                    <Modal open={modal}>
                        <div>
                            Удалить файл?<br/>
                            <button onClick={() => {setModal(false);}}>Отмена</button>
                            <button onClick={() => {setModal(false); deleteFile(numFileToDel)}}>Удалить</button>
                        </div>
                    </Modal>
                </>
                :
                <div style={{width: "100%", height: "30%", display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <div className="spinner"></div>
                </div>
            }
        </aside>
    );
};

export default observer(SideBar);
